import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import styles from "./styles.module.scss";
const RhodeFont = ({ children, className, style, }) => {
    return (_jsx("span", { className: cx(className, styles.rhode), style: style, children: children }));
};
export default RhodeFont;
